import { StyleProp, ViewStyle, View, StyleSheet } from 'react-native'
import SegmentControl from '../SegmentControl/SegmentControl'
import { DS } from '../../../design-system'

const firstDotColors = [
  DS.palette['Brand/Maroon'],
  DS.palette['Brand/Orange'],
  DS.palette['Brand/Pink'],
  DS.palette['Brand/Blue']
]
const secondDotColors = [DS.palette['Brand/Maroon'], DS.palette['Global/Black']]

const inactiveFirstDotColors = [
  DS.palette['Global/Black'],
  DS.palette['Global/Black'],
  DS.palette['Global/Black'],
  DS.palette['Global/Black']
]
const inactiveSecondDotColors = [DS.palette['Global/Black'], DS.palette['Global/Black']]

const Dots = ({
  dots,
  containerStyle,
  dotStyle,
  type
}: {
  dots: Array<string>
  containerStyle?: StyleProp<ViewStyle>
  dotStyle?: StyleProp<ViewStyle>
  type: 'active' | 'inactive'
}) => {
  return (
    <View style={[styles.dotsContainer, containerStyle]}>
      {dots.map((dotColor, index) => (
        <View
          key={`dot-${type}-${index}`}
          style={[
            styles.dot,
            { backgroundColor: dotColor },
            type === 'inactive' ? { opacity: 0.35 } : { opacity: 1 },
            dotStyle
          ]}
        />
      ))}
    </View>
  )
}

const INACTIVE_SEGMENTS = [
  {
    content: <Dots type="inactive" dots={inactiveFirstDotColors} />
  },
  {
    content: <Dots type="inactive" dots={inactiveSecondDotColors} />
  }
]

const ACTIVE_SEGMENTS = [
  {
    content: <Dots type="active" dots={firstDotColors} />
  },
  {
    content: <Dots type="active" dots={secondDotColors} />
  }
]

export const DrawerColorDots = ({
  initialSelectedIndex = 0,
  onChangeColorIndex
}: {
  initialSelectedIndex?: number
  onChangeColorIndex: (index: number) => void
}) => {
  return (
    <SegmentControl
      parentWidth={140}
      inactiveSegments={INACTIVE_SEGMENTS}
      activeSegments={ACTIVE_SEGMENTS}
      customSegmentStyle={{ paddingVertical: 8 }}
      initialSelectedIndex={initialSelectedIndex}
      onChangeIndex={(index) => {
        onChangeColorIndex(index)
      }}
    />
  )
}

const styles = StyleSheet.create({
  dotsContainer: {
    flexDirection: 'row',
    gap: 4
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4
  }
})
